/**
 * userApi.js
 * ユーザー・組織管理API（drone-ops-users-api Lambda）
 */

import { getSession, signOut } from './auth';

const API_BASE = process.env.REACT_APP_API_ENDPOINT;

async function authFetch(path, options = {}) {
  let session;
  try {
    session = await getSession();
  } catch (err) {
    signOut();
    window.location.href = '/login';
    throw new Error('Session expired');
  }
  const url = `${API_BASE}${path}`;
  const headers = {
    'Content-Type': 'application/json',
    Authorization: session.idToken,
    ...options.headers,
  };
  const response = await fetch(url, { ...options, headers });
  if (response.status === 401) {
    signOut();
    window.location.href = '/login';
    throw new Error('Unauthorized');
  }
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || `API Error: ${response.status}`);
  return data;
}

function normalizeUser(u) {
  return { ...u, name: u.displayName ?? u.email ?? '' };
}

export const userApi = {
  list: async (params = {}) => {
    const q = new URLSearchParams(params).toString();
    const data = await authFetch(`/users${q ? `?${q}` : ''}`);
    const users = (data.items ?? data.users ?? []).map(normalizeUser);
    return { users, count: users.length };
  },
  me      : ()             => authFetch('/users/me'),
  get     : (userId)       => authFetch(`/users/${userId}`),
  invite  : (body)         => authFetch('/users/invite', { method: 'POST', body: JSON.stringify(body) }),
  update  : (userId, body) => authFetch(`/users/${userId}`, { method: 'PATCH', body: JSON.stringify(body) }),
  register: (body)         => authFetch('/users/register', { method: 'POST', body: JSON.stringify(body) }),
};

// Legacy function exports for backward compatibility
export const registerUser = userApi.register;
export const getMyProfile = userApi.me;
export const getOrgMembers = userApi.list;
export const inviteMember = userApi.invite;

/**
 * 組織にアップグレード（個人→組織）
 */
export async function upgradeToOrganization({ orgName }) {
  return authFetch('/users/upgrade', {
    method: 'POST',
    body: JSON.stringify({ orgName }),
  });
}

/**
 * 招待トークンの確認
 */
export async function getInvitation(token) {
  const res = await fetch(`${API_BASE}/users/invite/${token}`);
  if (!res.ok) throw new Error('招待が見つかりません');
  return res.json();
}

/**
 * 招待を承認（既存個人ユーザーの組織参加）
 */
export async function acceptInvitation({ token, transferData }) {
  return authFetch(`/users/invite/${token}/accept`, {
    method: 'POST',
    body: JSON.stringify({ transferData }),
  });
}
